import React from "react";
import { Stack, Typography, Box, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

function UnabledIngredientUnitDialog({ state, handleClose }) {
  const navigate = useNavigate();
  const errorMessage = state?.errorMessage[0];
  const errorData = state?.errorData;
  const displayedRecipes = errorData?.slice(0, 3);
  const remainingRecipes = errorData?.length - 3;

  return (
    <Stack
      px="16px"
      display="flex"
      flexDirection="column"
      sx={{
        overflowY: "auto",
        maxHeight: "60vh",
        minHeight: "100px",

        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": { display: "none" },
        "&:hover": {
          "&::-webkit-scrollbar": { display: "initial" },
          "-ms-overflow-style": "initial",
        },
      }}
    >
      <Box>
        <Typography>{errorMessage}</Typography>
        {errorData?.length > 0 && (
          <>
            <Typography mt="16px" fontWeight={500}>
              Recipes -
            </Typography>
            <Stack spacing={0.5}>
              {displayedRecipes?.map((recipe, index) => (
                <Stack
                  direction="row"
                  key={index}
                  spacing={1}
                  alignItems="center"
                >
                  <Typography
                    component="span"
                    fontSize="14px"
                    color={"#3D4758"}
                  >
                    •
                  </Typography>
                  <Typography
                    component="span"
                    fontSize="16px"
                    color={"#3D4758"}
                    sx={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => {
                      navigate(`/recipe/details/${recipe.id}/?basic-details`);
                    }}
                  >
                    {recipe.name}
                  </Typography>
                  {index === displayedRecipes?.length - 1 &&
                    remainingRecipes > 0 && (
                      <Tooltip
                        title={
                          <Stack spacing={0.5}>
                            {errorData.slice(3).map((recipes, idx) => (
                              <Typography
                                key={idx}
                                fontSize="14px"
                                sx={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  navigate(
                                    `/recipe/details/${recipes.id}/?basic-details`
                                  );
                                  handleClose();
                                }}
                              >
                                {recipes.name}
                              </Typography>
                            ))}
                          </Stack>
                        }
                        arrow
                        placement="top"
                      >
                        <Typography
                          fontWeight={600}
                          sx={{
                            cursor: "pointer",
                            color: "#000000",
                            fontSize: "16px",
                          }}
                        >
                          +{remainingRecipes} More Recipes
                        </Typography>
                      </Tooltip>
                    )}
                </Stack>
              ))}
            </Stack>
          </>
        )}
      </Box>
    </Stack>
  );
}

export default UnabledIngredientUnitDialog;
